export default __webpack_public_path__ + "static/media/bg-water.aed0cbce.png";